import { render, staticRenderFns } from "./AddOrderInput.vue?vue&type=template&id=7b23becc&scoped=true&"
import script from "./AddOrderInput.vue?vue&type=script&lang=js&"
export * from "./AddOrderInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b23becc",
  null
  
)

export default component.exports